import { cn } from "@/modules/lib/utils"
import { useBoxLead } from "@modules/boxLead/hooks/useBoxLeadDetails"
import { PublicProfileDetails } from "@modules/profile/publicProfile/components/publicProfileDetails"
import { useUserProfile } from "@modules/profile/publicProfile/hooks/useUserProfile"
import { LoadingSpinner } from "@/modules/ui/components/loading"

type BoxLeadPublicProfilProps = {
  leadId: string
  className?: string
} & React.ComponentProps<"div">

export function BoxLeadPublicProfil({ leadId, className, ...props }: BoxLeadPublicProfilProps) {
  const { data: leadDetails } = useBoxLead(leadId)
  const { data: publicProfile, isLoading } = useUserProfile(leadDetails.user?.id ?? "")

  if (isLoading) return <LoadingSpinner className="flex h-min w-full pt-15" />
  if (!publicProfile) return null
  return <PublicProfileDetails publicProfile={publicProfile} className={cn("pt-5", className)} {...props} />
}
